import { createQueryKey } from 'src/utils/query/createQueryKey';

export const slotQueryKeys = {
	slot: () => createQueryKey('slot'),
};
